module.exports = __webpack_public_path__ + "static/ARB_PHOTOGRAPHY_3-946668e6b2cf6acba83db46b537c1b36.jpg";